module.exports = "<div *ngIf=\"user\">{{user.shortName}} <button class=\"btn btn-danger\" (click)=\"logout()\" *ngIf=\"logged\">Odhlásit</button></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.html
// module id = 460
// module chunks = 1